import { useState, useRef, useEffect } from "react";

export default function DemoModal() {
  const [open, setOpen] = useState(false);
  const [muted, setMuted] = useState(true);
  const [isSmall, setIsSmall] = useState(window.innerWidth <= 600);
  const videoRef = useRef(null);

  // ✅ Update on screen resize
  useEffect(() => {
    const handleResize = () => {
      setIsSmall(window.innerWidth <= 600);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const styles = {
    demoBar: {
      position: "fixed",
      top: "50%",
      right: isSmall ? "-21px" : "-28px",
      fontSize: isSmall ? "8px" : "12px",
      transform: "translateY(-50%) rotate(-90deg)",
      background: "#0d6b68",
      color: "#fff",
      padding: isSmall ? "4px 8px" : "6px 8px",
      fontWeight: "700",
      borderRadius: "10px 10px 0 0",
      cursor: "pointer",
      zIndex: 9999
    },
    modalOverlay: {
      position: "fixed",
      inset: 0,
      background: "rgba(0,0,0,0.75)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 99999
    },
    modalBox: {
      position: "relative",
      width: "90%",
      maxWidth: "850px",
      borderRadius: "20px",
      overflow: "hidden",
      background: "#000"
    },
    closeBtn: {
      position: "absolute",
      top: "12px",
      right: "18px",
      fontSize: "38px",
      cursor: "pointer",
      color: "red",
      zIndex: 100000,
      pointerEvents: "auto"
    },
    video: {
      width: "100%",
      height: isSmall ? "45vh" : "60vh",
      objectFit: "cover"
    },
    soundBtn: {
      position: "absolute",
      bottom: isSmall ? "12px" : "20px",
      right: isSmall ? "12px" : "20px",
      background: "rgba(0,0,0,0.55)",
      border: "none",
      color: "white",
      fontSize: isSmall ? "16px" : "20px",
      padding: isSmall ? "8px 10px" : "10px 14px",
      borderRadius: "50%",
      cursor: "pointer",
      backdropFilter: "blur(6px)",
      transition: "0.3s"
    }
  };

  const toggleSound = () => {
    if (videoRef.current) {
      videoRef.current.muted = !videoRef.current.muted;
      setMuted(videoRef.current.muted);
    }
  };

  return (
    <>
      <div onClick={() => setOpen(true)} style={styles.demoBar}>
        VIEW DEMO
      </div>

      {open && (
        <div style={styles.modalOverlay} onClick={() => setOpen(false)}>
          <div style={styles.modalBox} onClick={(e) => e.stopPropagation()}>
            <span style={styles.closeBtn} onClick={() => setOpen(false)}>
              &times;
            </span>

            <video
              ref={videoRef}
              autoPlay
              loop
              playsInline
              muted={muted}
              style={styles.video}
            >
              <source src="http://media.w3.org/2010/05/sintel/trailer.mp4" type="video/mp4" />
            </video>

            <button onClick={toggleSound} style={styles.soundBtn}>
              {muted ? <i className="fas fa-volume-mute"></i> : <i className="fas fa-volume-up"></i>}
            </button>
          </div>
        </div>
      )}
    </>
  );
}
